import React, { useState } from "react";
import Layout from "../../../layout/Layout";
import axios from "axios";
import { useEffect, useRef } from "react";

import {
  Grid,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Snackbar,
  Alert as MuiAlert,
  Typography,
  Divider,
  TextField,
  IconButton,
  Tooltip,
  Button,
  CircularProgress,
  Backdrop,
  Card,
  CardContent,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { config, serviceLevelAgreementsAPI, statusAPI } from "../../../config";

function Sla() {
  const flagUseEffect = useRef(false);
  const [messageType, setMessageType] = React.useState("success");
  const [message, setMessage] = React.useState("");
  const [isSubmitDisable, setIsSubmitDisable] = useState(false);

  // User SLA
  const [intGracePeriod, setGracePeriod] = useState("");
  const [txtStatus, setTxtStatus] = useState(2);

  // Vendor SLA
  const [intVendorGracePeriod, setVendorGracePeriod] = useState("");
  const [txtVendorStatus, setTxtVendorStatus] = useState(2);

  const [open, setOpen] = React.useState(false);

  const {
    handleSubmit,
    formState,
    setValue,
  } = useForm({ mode: "onChange" });

  const {
    handleSubmit: handleVendorSubmit,
    formState: vendorFormState,
    setValue: setVendorValue,
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    if (flagUseEffect.current === false) {
      // Fetch User SLA (intSPType: 2)
      const data = JSON.stringify({ intID: 0, intGracePeriod: 0, intStatus: 0, intSPType: 2 });
      fetchSLA(data, (row) => {
        setGracePeriod(row.grace_period);
        setTxtStatus(row.status);
        setValue("intGracePeriod", row.grace_period);
        setValue("txtStatus", row.status);
      });

      // Fetch Vendor SLA (intSPType: 4)
      const vendorData = JSON.stringify({ intID: 0, intGracePeriod: 0, intStatus: 0, intSPType: 4 });
      fetchSLA(vendorData, (row) => {
        setVendorGracePeriod(row.grace_period);
        setTxtVendorStatus(row.status);
        setVendorValue("intVendorGracePeriod", row.grace_period);
        setVendorValue("txtVendorStatus", row.status);
      });

      return () => {
        flagUseEffect.current = true;
      };
    }
  }, []);

  const fetchSLA = (data, callback) => {
    const cfg = { ...config, method: "post", url: serviceLevelAgreementsAPI, data };
    axios(cfg)
      .then((response) => {
        const row = response.data["data"]?.[0];
        if (row) callback(row);
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  const submitSLA = (spType, gracePeriod, status) => {
    setIsSubmitDisable(true);
    const responseData = JSON.stringify({
      intID: 0,
      intGracePeriod: gracePeriod,
      intStatus: status,
      intSPType: spType,
    });
    const cfg = { ...config, method: "Post", url: serviceLevelAgreementsAPI, data: responseData };
    axios(cfg)
      .then((response) => {
        setOpen(true);
        setMessageType("success");
        setMessage(response.data.message);
        setIsSubmitDisable(false);
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        setOpen(true);
        setMessageType("warning");
        setMessage(error?.response?.data?.message || "Something went wrong");
        setIsSubmitDisable(false);
      });
  };

  function onSubmit() {
    submitSLA(1, intGracePeriod, txtStatus);
  }

  function onVendorSubmit() {
    submitSLA(3, intVendorGracePeriod, txtVendorStatus);
  }

  return (
    <Layout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isSubmitDisable}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>

      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={messageType} sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>

      <Grid container spacing={3}>
        {/* User SLA Card */}
        <Grid item xs={12}>
          <Typography variant="h6" fontWeight="600" mb={1}>
            User SLA
          </Typography>
          <div className="background--white">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={5}>
                <Grid item xs={12} md={3} lg={3}></Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <FormControl fullWidth>
                    <TextField
                      name="intGracePeriod"
                      type="number"
                      label="Grace Period"
                      value={intGracePeriod}
                      onChange={(e) => {
                        setGracePeriod(e.target.value);
                        setValue("intGracePeriod", e.target.value);
                      }}
                      helperText="( in hours )"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3} lg={3}>
                  <FormControl fullWidth>
                    <Select
                      value={txtStatus}
                      onChange={(e) => {
                        setTxtStatus(e.target.value);
                        setValue("txtStatus", e.target.value);
                      }}
                    >
                      <MenuItem value={`2`}>Active</MenuItem>
                      <MenuItem value={`3`}>Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} lg={12} textAlign="center" className="top-padding-0">
                  <FormControl>
                    <Button
                      size="large"
                      variant="outlined"
                      color="primary"
                      type="submit"
                      className="btn-primary"
                      disabled={isSubmitDisable}
                    >
                      Submit
                    </Button>
                  </FormControl>
                </Grid>
              </Grid>
            </form>
          </div>
        </Grid>

        {/* Vendor SLA Card */}
        <Grid item xs={12}>
          <Typography variant="h6" fontWeight="600" mb={1}>
            Vendor SLA
          </Typography>
          <div className="background--white">
            <form onSubmit={handleVendorSubmit(onVendorSubmit)}>
              <Grid container spacing={5}>
                <Grid item xs={12} md={3} lg={3}></Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <FormControl fullWidth>
                    <TextField
                      name="intVendorGracePeriod"
                      type="number"
                      label="Grace Period"
                      value={intVendorGracePeriod}
                      onChange={(e) => {
                        setVendorGracePeriod(e.target.value);
                        setVendorValue("intVendorGracePeriod", e.target.value);
                      }}
                      helperText="( in hours )"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3} lg={3}>
                  <FormControl fullWidth>
                    <Select
                      value={txtVendorStatus}
                      onChange={(e) => {
                        setTxtVendorStatus(e.target.value);
                        setVendorValue("txtVendorStatus", e.target.value);
                      }}
                    >
                      <MenuItem value={`2`}>Active</MenuItem>
                      <MenuItem value={`3`}>Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} lg={12} textAlign="center" className="top-padding-0">
                  <FormControl>
                    <Button
                      size="large"
                      variant="outlined"
                      color="primary"
                      type="submit"
                      className="btn-primary"
                      disabled={isSubmitDisable}
                    >
                      Submit
                    </Button>
                  </FormControl>
                </Grid>
              </Grid>
            </form>
          </div>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default Sla;
